"use strict";

exports.__esModule = true;
var _MultiDeviceSelector = require("./MultiDeviceSelector");
Object.keys(_MultiDeviceSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MultiDeviceSelector[key]) return;
  exports[key] = _MultiDeviceSelector[key];
});